// src/services/bankService.js
import axios from 'axios';
import { API_BASE_URL } from '../config';

// Function to get CSRF token
function getCsrfToken() {
    return document.cookie.split('; ')
        .find(row => row.startsWith('csrftoken='))
        ?.split('=')[1];
}

// API endpoints
const BANKS_URL = `${API_BASE_URL}/banks/`;

export const getAllBanks = async () => {
    try {
        console.log('Fetching banks from:', BANKS_URL);
        const response = await axios.get(BANKS_URL, {
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCsrfToken()
            },
            withCredentials: true
        });
        console.log('Bank API Response:', response);
        console.log('Bank Data:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching banks:', error);
        throw error;
    }
};

export const getBankById = async (id) => {
    try {
        console.log(`Fetching bank ${id} from: ${BANKS_URL}${id}/`);
        const response = await axios.get(`${BANKS_URL}${id}/`, {
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCsrfToken()
            },
            withCredentials: true
        });
        console.log('Bank Detail Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching bank:', error);
        throw error;
    }
};

export const addBank = async (bankData) => {
    try {
        console.log('Adding bank with data:', bankData);
        const response = await axios.post(BANKS_URL, bankData, {
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCsrfToken()
            },
            withCredentials: true
        });
        console.log('Add Bank Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error adding bank:', error);
        throw error;
    }
};

export const updateBank = async (bankData) => {
    try {
        console.log('Updating bank with data:', bankData);
        const response = await axios.put(`${BANKS_URL}${bankData.id}/`, bankData, {
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCsrfToken()
            },
            withCredentials: true
        });
        console.log('Update Bank Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error updating bank:', error);
        throw error;
    }
};

export const deleteBank = async (bankId) => {
    try {
        console.log(`Deleting bank ${bankId}`);
        const response = await axios.delete(`${BANKS_URL}${bankId}/`, {
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCsrfToken()
            },
            withCredentials: true
        });
        console.log('Delete Bank Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error deleting bank:', error);
        throw error;
    }
};
